import type { ColumnDef } from '../models/gridReactTable'
import { GridCellCheckboxRenderer } from '../components/columnSelection/GridCellCheckboxRenderer'
import { GridHeaderCheckbox } from '../components/columnSelection/GridHeaderCheckbox'

export const GRID_CHECKBOX_SELECTION_FIELD = '__check__'

export const GRID_CHECKBOX_SELECTION_COL_DEF: ColumnDef<any, any> = {
  id: GRID_CHECKBOX_SELECTION_FIELD,
  header: GridHeaderCheckbox,
  // @ts-ignore
  cell: GridCellCheckboxRenderer,
  accessorKey: GRID_CHECKBOX_SELECTION_FIELD,
  maxSize: 57,
  minSize: 57,
  enablePinning: false,
  enableResizing: false,
  enableSorting: false,
  enableMultiSort: false,
  enableColumnFilter: false,
  enableHiding: false,
  meta: { align: 'center', headerAlign: 'center', disableReorder: true },
}

// @ts-ignore
export const GRID_CHECKBOX_SELECTION_COL_DEF_WITHOUT_HEADER: ColumnDef<
  any,
  any
> = {
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  header: () => null,
}
